import { get } from 'lodash'
import { FormattedHTMLMessage } from 'react-intl'
import React from 'react'

export const getPraiseDescription = notification => {
  const authorName = get(notification, 'author.name')

  const activityCategoryName = get(notification, 'activityLog.activity.activityCategory.translatedName')

    return (<FormattedHTMLMessage
      id="label.notification_praise_description"
      defaultMessage="{authorName} sends a message on your {activityCategoryName} activity log:"
      values={{
        authorName: authorName,
        activityCategoryName: activityCategoryName
      }}
    />)

}
